import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const emergencyContactUsContainer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s48,
});

export const emergencyContactUsFooter = style([
  typography.bodyMd,
  { color: themeVars.container.foreground.secondary },
]);
